<template>
  <v-container fluid>
    <v-row class="pt-2">
      <v-col cols="auto" v-for="(photo, index) in unitPhotosWithPlaceholder" :key="photo.id">
        <div class="photo-container" @click="$emit('selectPhoto', index)">
          <div class="photo-overlay"><EsButtonIcon :icon="photo.id === pinnedPhoto ? 'mdi-pin' : 'mdi-pin-outline'" dark @click="$emit('pinPhoto', photo.id)" /></div>
          <div class="photo-tag gold">{{photo.photoType === 'Serial Photo' ? 'Serial' : 'Unit'}}</div>
          <v-img class="photo" height="75" width="75" :src="getSignedUrl ? getSignedUrl(photo.photoUrl) : photo.photoUrl"></v-img>
        </div>
      </v-col>
      <v-col v-if="uploadLoading">
        <div
          class="d-flex justify-center align-center"
          style="width: 75px; height: 75px; background-color: grey"
        >
          <v-progress-circular indeterminate></v-progress-circular>
        </div>
      </v-col>
      <v-col v-else>
        <div class="photo-container" @click="addPhoto('Unit Photo')" @drop.stop.prevent="handleDropFileUpload($event, 'Unit Photo')" @dragenter.prevent @dragover.prevent>
          <div class="photo-tag gold">Unit</div>
          <div class="photo d-flex justify-center"><v-icon>mdi-plus</v-icon></div>
        </div>
      </v-col>
    </v-row>
    <v-row class="pt-2">
      <v-col cols="auto" v-for="(photo, index) in serialPhotosWithPlaceholder" :key="photo.id">
        <div class="photo-container" @click="$emit('selectPhoto', serialIndex(index))">
          <div class="photo-overlay"><EsButtonIcon :icon="photo.id === pinnedPhoto ? 'mdi-pin' : 'mdi-pin-outline'" dark @click="$emit('pinPhoto', photo.id)" /></div>
          <div class="photo-tag">{{photo.photoType}}</div>
          <v-img class="photo" height="75" width="75" :src="getSignedUrl ? getSignedUrl(photo.photoUrl) : photo.photoUrl"></v-img>
        </div>
      </v-col>
      <v-col v-if="uploadLoading">
        <div
          class="d-flex justify-center align-center"
          style="width: 75px; height: 75px; background-color: grey"
        >
          <v-progress-circular indeterminate></v-progress-circular>
        </div>
      </v-col>
      <v-col v-else>
        <div class="photo-container" @click="addPhoto('Serial Photo')" @drop.stop.prevent="handleDropFileUpload($event, 'Serial Photo')" @dragenter.prevent @dragover.prevent>
          <div class="photo-tag">Serial</div>
          <div class="photo d-flex justify-center"><v-icon>mdi-plus</v-icon></div>
        </div>
      </v-col>
    </v-row>
    <input
      ref="photoUpload"
      multiple
      accept="image/*"
      type="file"
      @change="handleClickFileUpload($event)"
      hidden
    />
  </v-container>
</template>

<script>
export default {
  name: 'EsAssetPhotoUploader',
  props: {
    photos: {
      type: Array,
    },
    uploadHandler: {
      type: Function,
      default: async () => {
        console.log('no handler');
      },
    },
    pinnedPhoto: {
      type: String,
    },
    getSignedUrl: {
      type: Function,
      required: false,
    }
  },
  data() {
    return {
      uploadLoading: false,
      photoType: null,
    };
  },
  computed: {
    serialPhotosWithPlaceholder() {
      return this.photos?.filter((photo) => photo.photoType === 'Serial Photo') || [];
    },
    unitPhotosWithPlaceholder() {
      return this.photos?.filter((photo) => photo.photoType === 'Unit Photo') || [];
    },
  },
  methods: {
    serialIndex(index) {
      return (this.unitPhotosWithPlaceholder?.length || 0) + index;
    },
    addPhoto(type) {
      this.photoType = type;
      this.$refs.photoUpload.click();
    },
    async handleFileUpload(filesArray) {
      this.uploadLoading = true;
      try {
        await Promise.all(filesArray.map((file) => this.uploadHandler(file, this.photoType)));
      } catch (err) {
        // this.customError('Image upload failed');
      } finally {
        this.uploadLoading = false;
        this.photoType = null;
        this.$refs.photoUpload.value = null;
      }
    },
    handleClickFileUpload(e) {
      this.handleFileUpload(Array.from(e.target.files));
    },
    handleDropFileUpload(e, type) {
      this.photoType = type;
      const imageFiles = Array.from(e.dataTransfer.files)?.filter((file) => file.type.includes('image'));
      this.handleFileUpload(imageFiles);
    },
  },
};
</script>

<style lang="scss" scoped>
.photo-container {
  position: relative;
  width: 75px;
  height: 75px;
  cursor: pointer;
  background-color: grey;
  border-radius: 4px;

  &:hover {
    .photo-overlay {
      opacity: 1;
    }
  }

  .photo-overlay {
    position: absolute;
    z-index: 3;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    opacity: 0;
    transition: opacity 0.4s;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }

  .photo-tag {
    position: absolute;
    z-index: 4;
    background-color: var(--v-primary-base);
    color: white;
    border-bottom-right-radius: 4px;
    border-top-left-radius: 4px;
    padding: 0 0.5rem;

    &.gold {
      background-color: #aa6c39;
    }
  }

  .photo {
    position: absolute;
    z-index: 1;
    height: 100%;
    width: 100%;
    border-radius: 4px;
    display: flex;
  }
}
</style>
